/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheClasseHoraireRemplacementSimultaneSearch
 */
export interface RechercheClasseHoraireRemplacementSimultaneSearch {
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    idRemplacement?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    classeMatiere?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    remplacant?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    contrat?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheClasseHoraireRemplacementSimultaneSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheClasseHoraireRemplacementSimultaneSearch interface.
 */
export function instanceOfRechercheClasseHoraireRemplacementSimultaneSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheClasseHoraireRemplacementSimultaneSearchFromJSON(json: any): RechercheClasseHoraireRemplacementSimultaneSearch {
    return RechercheClasseHoraireRemplacementSimultaneSearchFromJSONTyped(json, false);
}

export function RechercheClasseHoraireRemplacementSimultaneSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheClasseHoraireRemplacementSimultaneSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idRemplacement': !exists(json, 'idRemplacement') ? undefined : json['idRemplacement'],
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'classeMatiere': !exists(json, 'classeMatiere') ? undefined : TextSearchFromJSON(json['classeMatiere']),
        'remplacant': !exists(json, 'remplacant') ? undefined : TextSearchFromJSON(json['remplacant']),
        'contrat': !exists(json, 'contrat') ? undefined : TextSearchFromJSON(json['contrat']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheClasseHoraireRemplacementSimultaneSearchToJSON(value?: RechercheClasseHoraireRemplacementSimultaneSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idRemplacement': value.idRemplacement,
        'classe': TextSearchToJSON(value.classe),
        'classeMatiere': TextSearchToJSON(value.classeMatiere),
        'remplacant': TextSearchToJSON(value.remplacant),
        'contrat': TextSearchToJSON(value.contrat),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

